import { message, Select, Input } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  InputItem,
  InputNumberItem,
  DatePickerItem,
  SelectItem,
  SwitchItem,
  ButtonItem,
  ErrorItem,
  TextAreaItem,
  TourItem,
  cuentaMask,
} from "../../../../Components/Items";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";

const { Option } = Select;

class AgregarUnidadActivoFijo extends Component {
  formRef = React.createRef();
  refCosto = React.createRef();
  refFechas = React.createRef();
  refLibre = React.createRef();
  refFolio = React.createRef();
  refContabilizar = React.createRef();
  state = {
    loading: false,
    openTour: false,
    objetoProyectos: null,
    objetoCuentaContable: null,
    objetoActivos: null,
    modalAgregarCuentaContable: false,
  };
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.consultarProyectos();
      this.consultarCuentasContables();
      if (!this.props.insumoId) this.consultarActivos();
    }
  }
  // Solo se usa cuando el modal se abre sin un Activo ya elegido (ej. desde
  // el listado general de Inventario de Activos, en vez de la pantalla por Activo).
  consultarActivos() {
    axios
      .post("activosFijos/selectActivosFijos", { empresaId: this.props.empresaId, valor: 1 }, { headers: this.props.headersToken })
      .then((res) => {
        if (Array.isArray(res.data)) {
          this.setState({
            objetoActivos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>{value.descripcion}</Option>
            )),
          });
        }
      });
  }
  consultarProyectos() {
    axios
      .post("proyectos/selectProyectos", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>{value.nombre}</Option>
            )),
          });
        }
      });
  }
  consultarCuentasContables() {
    axios
      .post("cuentascontables/selectCuentasContablesFinales", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoCuentaContable: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5) + " - " + value.descripcion}
              </Option>
            )),
          });
        }
      });
  }
  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarCuentasContables();
  }
  cerrarAgregarUnidadActivoFijo(codigo) {
    this.props.cerrarAgregarUnidadActivoFijo(codigo);
    if (this.formRef.current) this.formRef.current.resetFields();
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "activosFijos/agregarUnidadActivoFijo",
        {
          ...values,
          insumoId: this.props.insumoId || values.insumoId,
          proyectoId: values.proyectoId || this.props.proyectoId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha registrado la unidad");
          this.cerrarAgregarUnidadActivoFijo(res.data.codigo);
        } else {
          message.error(res.data.message || "Hubo un error y la unidad no se registró");
        }
      });
  }
  render() {
    const steps = [
      {
        title: "Alta de una unidad física",
        description: "Cada unidad es UN bien físico concreto (ej. la laptop con número de serie XYZ), no el modelo/Activo en general. El costo y la fecha que captures aquí son los que se usan para calcular la depreciación de ESTA unidad específicamente.",
        target: null,
      },
      {
        title: "Costo y Proyecto",
        description: "El costo de adquisición es el valor real que se deprecia (puede ser distinto entre unidades del mismo Activo). El proyecto/almacén es dónde físicamente está ubicada.",
        target: () => this.refCosto.current,
      },
      {
        title: "Fechas",
        description: "La depreciación empieza a correr desde 'Fecha Inicio Depreciación' (por default, igual a la fecha de adquisición — puedes capturar una distinta si el activo entró en uso después de comprarlo).",
        target: () => this.refFechas.current,
      },
      {
        title: "Datos libres",
        description: "Ubicación física, fabricante, proveedor y orden de compra son solo informativos — no afectan ningún cálculo contable.",
        target: () => this.refLibre.current,
      },
      {
        title: "Serie y Folio",
        description: "Si los dejas vacíos, se generan automáticamente usando el prefijo y consecutivo configurados en el Tipo de Activo (o en el Activo si tiene su propio contador). Solo captúralos a mano si necesitas un folio específico.",
        target: () => this.refFolio.current,
      },
      {
        title: "Póliza inicial (opcional)",
        description: "Si el costo de esta unidad NO está contabilizado todavía, activa 'Contabilizar' y elige una cuenta de ajuste: se genera una póliza con Cargo a la Cuenta del Activo y Abono a esa cuenta. Si el valor ya está contabilizado por otro medio (ej. ya viene de una compra registrada), déjalo apagado y no se genera ninguna póliza — a diferencia de Agregar Inventario, aquí siempre es 1 unidad.",
        target: () => this.refContabilizar.current,
      },
    ];
    return (
      <>
        <ModalItem
          title={
            <span>
              Agregar Unidad de Activo{" "}
              <ButtonItem type="link" size="small" blanco onClick={() => this.setState({ openTour: true })}>¿Cómo funciona?</ButtonItem>
            </span>
          }
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarAgregarUnidadActivoFijo.bind(this)}
          paddingTop
          width={700}
        >
          <Form
            ref={this.formRef}
            name="agregarUnidadActivoFijo"
            layout
            bottom={
              <ButtonItem type="primary" htmlType="submit" style={{ display: "block", margin: "0 0 0 auto" }}>
                Agregar
              </ButtonItem>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <div ref={this.refCosto}>
              {!this.props.insumoId && (
                <FormItem
                  name="insumoId"
                  label="Activo"
                  required
                  margin
                  tooltip={{ title: "A qué Activo (modelo) pertenece esta nueva unidad física. Solo aparece aquí porque abriste este formulario desde el listado general de Inventario de Activos." }}
                >
                  <SelectItem placeholder="Selecciona el Activo">
                    {this.state.objetoActivos}
                  </SelectItem>
                </FormItem>
              )}
              <FormItem
                name="proyectoId"
                label="Proyecto / Almacén"
                required
                margin
                initialValue={this.props.proyectoId}
                tooltip={{ title: "Proyecto/almacén donde físicamente se ubica esta unidad." }}
              >
                <SelectItem placeholder="Proyecto / Almacén">
                  {this.state.objetoProyectos}
                </SelectItem>
              </FormItem>
              <FormItem
                name="costo"
                label="Costo de Adquisición"
                required
                margin
                tooltip={{ title: "Costo REAL de esta unidad específica. Es el valor que se usa para calcular su depreciación: (Costo − Valor Residual) × Depreciación Anual %." }}
              >
                <InputNumberItem placeholder="Costo de adquisición" dinero />
              </FormItem>
            </div>
            <div ref={this.refFechas}>
              <FormItem
                name="fechaAdquisicion"
                label="Fecha de Adquisición"
                required
                margin
                tooltip={{ title: "Cuándo entra el activo a operar/inventario." }}
              >
                <DatePickerItem placeholder="Fecha de adquisición" style={{ width: "100%" }} format="DD/MM/YYYY" />
              </FormItem>
              <FormItem
                name="fechaInicioDepreciacion"
                label="Fecha Inicio Depreciación"
                margin
                tooltip={{ title: "Desde cuándo empieza a correr la depreciación de esta unidad. Si se deja vacío, se usa la fecha de adquisición." }}
              >
                <DatePickerItem placeholder="Default: fecha de adquisición" style={{ width: "100%" }} format="DD/MM/YYYY" />
              </FormItem>
              <FormItem name="fechaCompra" label="Fecha de Compra" margin tooltip={{ title: "Fecha de la orden/factura de compra (puede diferir de la fecha en que entró en uso)." }}>
                <DatePickerItem placeholder="Fecha de la orden/factura de compra" style={{ width: "100%" }} format="DD/MM/YYYY" />
              </FormItem>
              <FormItem name="fechaFabricacion" label="Fecha de Fabricación" margin tooltip={{ title: "Fecha de fabricación reportada por el fabricante (opcional, informativo)." }}>
                <DatePickerItem placeholder="Fecha de fabricación" style={{ width: "100%" }} format="DD/MM/YYYY" />
              </FormItem>
            </div>
            <div ref={this.refLibre}>
              <FormItem name="ubicacionFisica" label="Ubicación Física" margin pattern tooltip={{ title: "Dónde está físicamente el activo (ej. 'Oficina Gerencia, Planta 1'). Informativo." }}>
                <InputItem placeholder="Ej. Oficina Gerencia, Planta 1" />
              </FormItem>
              <FormItem name="fabricante" label="Fabricante" margin pattern tooltip={{ title: "Fabricante del equipo/bien. Informativo." }}>
                <InputItem placeholder="Fabricante" />
              </FormItem>
              <FormItem name="proveedor" label="Proveedor" margin pattern tooltip={{ title: "Proveedor que vendió esta unidad (texto libre, no ligado al catálogo de Proveedores). Informativo." }}>
                <InputItem placeholder="Proveedor" />
              </FormItem>
              <FormItem name="ordenDeCompra" label="Orden de Compra" margin pattern tooltip={{ title: "Referencia manual a la orden de compra o factura relacionada. Informativo." }}>
                <InputItem placeholder="Referencia de orden de compra" />
              </FormItem>
            </div>
            <div ref={this.refFolio}>
              <FormItem name="serieActivo" label="Serie (opcional)" margin tooltip={{ title: "Si se deja vacío, se autogenera con el prefijo configurado en el Tipo de Activo/Activo." }}>
                <InputItem placeholder="Autogenerado si se deja vacío" />
              </FormItem>
              <FormItem name="numero" label="Folio (opcional)" margin tooltip={{ title: "Si se deja vacío, se autogenera con el consecutivo configurado." }}>
                <InputItem placeholder="Autogenerado si se deja vacío" />
              </FormItem>
            </div>
            <div ref={this.refContabilizar}>
              <FormItem
                label="Contabilizar"
                name="contabilizar"
                margin
                initialValue={true}
                valuePropName="checked"
                tooltip={{ title: "Actívalo si el costo de esta unidad NO está contabilizado todavía: se generará una póliza inicial (Cargo a la Cuenta del Activo / Abono a la cuenta de ajuste que elijas). Desactívalo si el valor ya está contabilizado por otro medio — la unidad se da de alta sin generar ninguna póliza." }}
              >
                <SwitchItem />
              </FormItem>
              <FormItem noStyle shouldUpdate>
                {({ getFieldValue }) => {
                  if (!getFieldValue("contabilizar")) return null;
                  return (
                    <FormItem
                      label="Cuenta de Ajuste (Abono)"
                      margin
                      tooltip={{ title: "Cuenta contable que se abona al generar la póliza inicial de esta unidad (el cargo va a la Cuenta del Activo configurada en el Activo/Tipo de Activo)." }}
                    >
                      <Input.Group compact>
                        <FormItem name="cuentaAbonoId" required noStyle>
                          <SelectItem placeholder="Cuenta de Ajuste" width="85%">
                            {this.state.objetoCuentaContable}
                          </SelectItem>
                        </FormItem>
                        <ButtonItem
                          icon={<PlusOutlined />}
                          style={{ width: "13%", marginLeft: 5 }}
                          onClick={this.abrirAgregarCuentaContable.bind(this)}
                        />
                      </Input.Group>
                    </FormItem>
                  );
                }}
              </FormItem>
            </div>
            <FormItem name="observaciones" label="Observaciones" margin pattern tooltip={{ title: "Notas libres sobre esta unidad." }}>
              <TextAreaItem placeholder="Observaciones" />
            </FormItem>
          </Form>
        </ModalItem>
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(this)}
        />
        <TourItem open={this.state.openTour} onClose={() => this.setState({ openTour: false })} steps={steps} />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(AgregarUnidadActivoFijo);
